module.exports = __webpack_public_path__ + "img/logo.8cbc87e5.jpg";